/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ condition: NonNullable<unknown>, time: NonNullable<unknown> }} Ui_Weather_Change_FromInputs */

const en_ui_weather_change_from = /** @type {(inputs: Ui_Weather_Change_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.condition} from ${i?.time}`)
};

const de_ui_weather_change_from = /** @type {(inputs: Ui_Weather_Change_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.condition} ab ${i?.time}`)
};

/**
* | output |
* | --- |
* | "{condition} from {time}" |
*
* @param {Ui_Weather_Change_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_change_from = /** @type {((inputs: Ui_Weather_Change_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Change_FromInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_change_from(inputs)
	return de_ui_weather_change_from(inputs)
});